import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from "react-redux";
import { loginSuccess } from "./store/slices/pubLoginSlice"; // Import the loginSuccess action

export default function LoginBody() {
  const [data, setData] = useState({
    Phone: "",
    Password: ""
  });
  const [isLoading, setIsLoading] = useState(false); // State for loading animation
  const [isLoginDisabled, setIsLoginDisabled] = useState(false);
  const [timer, setTimer] = useState(null);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const navto = useNavigate();
  const dispatch = useDispatch();

  // Check if the rate limit was previously hit and if time has passed
  useEffect(() => {
    // Clear any previous timer if the user changes the phone number
    if (timer) clearTimeout(timer);

    if (!data.Phone) {
      setIsLoginDisabled(false);
      return; // No phone number, so button should be enabled
    }

    const lockTime = localStorage.getItem(`lockTime_${data.Phone}`);
    if (lockTime) {
      const timeElapsed = Date.now() - lockTime;
      const remainingTime = 900000 - timeElapsed; // 15 minutes

      if (remainingTime > 0) {
        setIsLoginDisabled(true);
        startTimer(remainingTime, data.Phone); // Start timer for the remaining duration
      } else {
        localStorage.removeItem(`lockTime_${data.Phone}`);
        setIsLoginDisabled(false);
      }
    } else {
      setIsLoginDisabled(false);
    }

    // Cleanup function to clear timer when component unmounts
    return () => {
      if (timer) clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.Phone]); // Dependency: runs when data.Phone changes

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  // Function to start the timer and disable the button
// Now accepts 'phone' to remove the correct key from localStorage
  const startTimer = (duration, phone) => {
    setIsLoginDisabled(true);
    setTimer(setTimeout(() => {
      setIsLoginDisabled(false);
      if (phone) {
        localStorage.removeItem(`lockTime_${phone}`);
      }
    }, duration));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Show loading animation

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/publicUser`, data);

      if (response.status === 200 && response.data.message === "Authentication successful") {
        dispatch(loginSuccess(data.Phone)); // Dispatch login success
        toast.success("Login successful!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        setTimeout(() => navto("/publicUser"), 1000);
      }
    } catch (error) {
      console.error("Login failed:", error.message);
      if (error.response) {
       if (error.response.status === 429) { // Too Many Requests
          toast.error("Too many login attempts. Please try after 15 minutes.", { position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined });
          
          // Set the *specific* lock key in localStorage
          localStorage.setItem(`lockTime_${data.Phone}`, Date.now());
          
          // Start the timer with the specific phone
          startTimer(900000, data.Phone); // 15 minutes
        
        } else { // For 404 (User not found) or other errors
          toast.error("Invalid login credentials", { position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined });
        }
        setShowForgotPassword(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = () => {
    navto("/forgotPassword");
  };

  useEffect(() => {
    return () => clearTimeout(timer); // Clear the timer when the component unmounts
  }, [timer]);

  return (
    <div className="container d-flex justify-content-center align-items-center vh-50">
      <form className="form-group w-75 mt-5 mb-5" onSubmit={handleLogin}>
        <label htmlFor="whnumInput">Whatsapp Number</label>
        <input
          type="tel"
          pattern="(\+?[0-9]{1,4})?[0-9]{10,14}"
          title="Please enter whatsapp number."
          name="Phone"
          id="whnumInput"
          className="form-control mb-2"
          placeholder="+91XXXXXXXXXX"
          onChange={handleChange}
          required
          disabled={isLoginDisabled} // Disable input during lockout period
        />
        <label htmlFor="passwordInput">Password</label>
        <input
          type="password"
          name="Password"
          id="passwordInput"
          minLength="8"
          className="form-control mb-2"
          placeholder="type your password"
          onChange={handleChange}
          required
          disabled={isLoginDisabled} // Disable input during lockout period
        />
        <div className="d-flex flex-column justify-content-center align-items-center">
          <button
            type="submit"
            className="btn btn-success btn-lg rounded-pill px-5 py-3 mt-4 mb-4 shadow"
            disabled={isLoginDisabled} // Disable button during lockout period
          >
            {isLoading ? (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
              isLoginDisabled ? 'Try again in 15 minutes' : 'Log In'
            )}
          </button>

          {/* Sign up button below login */}
          <button
            type="button"
            className="btn btn-primary btn-lg rounded-pill text-center px-5 py-3 mt-1 shadow"
            onClick={() => navto("/publicForm")}
          >
            Sign Up
          </button>
        </div>

        {showForgotPassword && (
          <div className="text-center mt-2">
            <span onClick={handleForgotPassword} style={{ color: 'blue', userSelect: 'none' }}>Forgot Password?</span>
          </div>
        )}
      </form>
      <ToastContainer />
    </div>
  );
}
